var modules_e185b7e9 = {"base-line":"_ljbe9n","effect":"_15i4wh7","inverted":"_1hywgo7","container":"_ojn4js","paragraph":"_19rhfm3 _ljbe9n","avatar":"_1it0e7m _ljbe9n","button":"_1bb90cb _ljbe9n","block":"_11otxi7"};
import "../../../assets/DgbveXd7.css";

export { modules_e185b7e9 as default };
//# sourceMappingURL=Skeleton.module.less.js.map
